export default ['bold', 'italic', 'underline', { color: [] }];
